import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal, computed } from '@angular/core';
import { ButtonModule, ContextMenuItem, ContextMenuService, KeycloakService } from '@atsystems/ui';
import { SelectionService } from '../../services/selection.service';
import { bottomContextMenuAnimation } from './animations/bottom-context-menu.animation';
import { toSignal } from '@angular/core/rxjs-interop';
import { fromEvent, map, startWith } from 'rxjs';
import { Roles } from 'src/app/common/helpers/roles';

@Component({
  selector: 'ats-bottom-context-menu',
  imports: [CommonModule, ButtonModule, OverlayModule],
  providers: [ContextMenuService],
  animations: [bottomContextMenuAnimation],
  templateUrl: './bottom-context-menu.component.html',
  styleUrl: './bottom-context-menu.component.sass',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomContextMenuComponent {
  private keycloakService = inject(KeycloakService);

  public selectedCount = signal<number>(0);
  public items = signal<ContextMenuItem[]>([]);
  public selectionService = inject(SelectionService);
  public contextMenuService = inject(ContextMenuService);

  public filteredItems = computed(() => {
    return this.items().filter(item => {
      if (!item.roles || item.roles.length === 0) return true;
      return this.keycloakService.hasResourceRole(item.roles);
    });
  });

  public decreasedView = signal<boolean>(false);

  private readonly resize$ = fromEvent(window, 'resize').pipe(
    map(() => window.innerWidth),
    startWith(window.innerWidth)
  );

  public windowWidth = toSignal(this.resize$, { initialValue: window.innerWidth });

  constructor() {}

  public toggleMenu(): void {
    this.decreasedView.update(value => !value);
  }

  public selectAll(): void {
    this.selectionService.setAllSelected();
  }

  public close(): void {
    this.selectionService.clearSelection();
  }

  public showMore(event: MouseEvent): void {
    this.contextMenuService.open(event, { data: this.items() }, true);
  }
}
